import TheGrid from '@/views/campaigns/inpar/leaderresults/grid'

export default {
  path: '/campaigns/inpar/leader-results',
  redirect: '/campaigns/inpar/leader-results/index',
  name: 'inparResults',
  meta: {
    auth: {
      redirect: {
        name: 'inparResults.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Resultados Leaders'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'inparResults.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }]
}
